export enum Path {
  DIRECTSEARCH_RESULTS = "/directsearch/search",
}
